import { useContent } from '../ContentContext';
import { PageHero, SectionHead } from '../components/Common';

export default function Recipes() {
  const { recipeGroups = [] } = useContent();
  const heroImg = recipeGroups[0]?.items?.[0]?.image;

  return (
    <>
      <PageHero title="Rice Recipes" image={heroImg} />

      {/* Sticky category nav */}
      <div className="recipe-nav-section">
        <div className="container">
          <nav className="recipe-nav">
            {recipeGroups.map((g) => (
              <a key={g.id} href={`#${g.id}`}>
                <i className={`fas ${g.icon || 'fa-utensils'}`} />
                {(g.title || '').replace(/\s*Recipes$/i, '')}
              </a>
            ))}
          </nav>
        </div>
      </div>

      {recipeGroups.map((g, i) => (
        <section key={g.id || i} id={g.id} className={`recipe-section ${i % 2 === 1 ? 'bg-light' : ''}`}>
          <div className="container">
            <SectionHead tag="Recipes" title={g.title} text={g.intro} />
            <div className="recipe-grid">
              {(g.items || []).map((r) => (
                <article className="recipe-card" key={r.slug || r.name}>
                  <img src={r.image} alt={r.name} loading="lazy" />
                  <div className="recipe-content">
                    <h3>{r.name}</h3>
                    <p>{r.text}</p>
                    <a className="recipe-btn" href={`#${g.id}`}>Read More</a>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>
      ))}
    </>
  );
}
